//=include core/resources/javascript/jquery/plugins/jquery.selectreplace.js

//=include plugins/welcome.js
//=include plugins/account-frozen.js
//=include plugins/points-expiry.js
//=include plugins/scheduled-notice.js
//=include plugins/header.js
//=include plugins/popup.js
//=include plugins/check-replace.js
//=include plugins/radio-style.js
//=include plugins/enquiry-form.js
//=include plugins/location-grid.js
//=include plugins/sub-nav.js
//=include plugins/stepper.js

//=include components/_filters.js
//=include components/_invoice-listing.js
//=include components/welcome.js
//=include components/account-frozen.js
//=include components/points-expiry.js
//=include components/scheduled-notice.js
//=include components/header.js
//=include components/popup.js
//=include components/input-replace.js
//=include components/enquiry-form.js
//=include components/location-grid.js
//=include components/sub-nav.js

//=include tools/loop.js
//=include tools/svg.js

Hideaways.welcome();
Hideaways.frozen();
Hideaways.pointsExpiry();
Hideaways.scheduledNotice();
Hideaways.header();
Hideaways.popup();
Hideaways.inputReplace();
Hideaways.enquiryForm();
Hideaways.subNav();

setTimeout(function() {
    Hideaways.locationGrid();
}, 100);

var HideawaysOld = {
    // Trigger a browser repaint
    repaint: function(elem, prop) {
        var e = elem ? elem : document.body;
        prop = prop ? prop : 'height';

        var v = $(e).css(prop);

        if (console && console.log) {
            console.log('Forced repaint, got value', v, 'for prop', prop);
        }

        $(e).data(prop, v);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    var externalTarget = window.location.hash;

    if (externalTarget != '') {
        var $target = $(externalTarget);

        if ($target.length) {
            scrollTo($target, false);
        }
    }
})

$(function() {
    $('.select-url').change(function() {
        var hash = window.location.hash;
        window.location = $(this).val() + hash;
    });

    /* TODO: Move into form template */
    $('input[type="checkbox"]').not('.filterable input').each(function() {
        var $field = $(this).parent();
        $field.find('input').insertBefore($field);
        $field.wrapInner('<span>');
    });

    $('.banner-slideshow').each(function() {
        var $frames = $(this).children('figure, div'),
            $pages  = $(this).find('.banner-slideshow__controls a'),
            showing = 0;

        var $slideshow = $(this);

        var timer = null,
            resetTimer = function() {
                if ($slideshow.hasClass('banner-slideshow--autoplay')) {
                    window.clearTimeout(timer);
                    timer = setTimeout(function() {
                        $pages.eq( (showing + 1) % $pages.length).click();
                    }, 3000);
                }
            };

        resetTimer();

        $pages.click(function(e) {
            resetTimer();
            var index = $pages.index(this);

            $frames.eq(showing).addClass('inactive');
            $frames.eq(index).removeClass('inactive');

            $pages.eq(showing).removeClass('active');
            $pages.eq(index).addClass('active');

            showing = index;
        });
    });

    var $tabs = $('.area-tabs a').click(function(e) {
        e.preventDefault();

        var i = $tabs.removeClass('active').index(
            $(this).addClass('active')
        );

        $(this).parent().parent().find('.area-tab-content').removeClass('active').eq(i).addClass('active');
    });

    $('.tabs--listing').each(function() {
        var $tabs    = $(this).find('.tabs__tab'),
            $content = $(this).find('.tabs__content');

        var tabActiveClass = 'tabs__tab--active';

        $tabs.click(function(e) {
            if ($(this).hasClass(tabActiveClass)) {
                return;
            }

            $tabs.removeClass(tabActiveClass);
            $(this).addClass(tabActiveClass);

            $content.hide().eq( $tabs.index(this) ).show();
        });
    });

    $('.sentence__results a').click(function() {
        $(this).closest('.filter__tab').hide().prev().show();
    });

    $('.show-floorplan').click(function(e) {
        e.preventDefault();
        $('#floorplans').show();
    });

    $('.floorplan__close a').click(function() {
        $('#floorplans').hide();
    });

    var $sentencePickers = $('.js-filter__form input.calendar').each(function(pickerI) {
        var $picker = $(this).datepicker({
            altField: $(this).next(),
            altFormat: 'yy-mm-dd',
            dateFormat: 'D d M y',
            onClose: function(selectedDate) {
                if (!pickerI) {
                    var date = $picker.datepicker("getDate");

                    date.setDate( date.getDate() + parseInt($('select[name="duration"]').val()));

                    $sentencePickers.eq((pickerI+1) %2).datepicker("option", pickerI ? "maxDate" : "minDate", date);
                }
            }
            // firstDay: $availability.data('changeover')
        });

        $(this).parent().on('click', function(e) {
            if ( !$(e.target).is('input')) {
                $picker.datepicker('show');
            }
        }).css('cursor', 'pointer');
    });

    $('select[name="duration"]').change(function() {
        var $picker = $sentencePickers.eq(0);
        $picker.datepicker('option', 'onClose').call($picker);
    });

    $('.ga-click-event').add('.sales-director a').click(function(e) {
        e.preventDefault();


        var action = $(this).data('gaaction');
        if (!action) {
            action = "Page";
        }

        if ($.isFunction(window.ga)) {
            ga('send', 'event', 'link-click', action, $(this).text());
        }

        window.location = $(this).attr('href');
    });

    $('#language-select').change(function() {
        window.location.href = window.location.href + '?loc=' + $(this).val();
    });

    $('.fademore__inner').each(function(){
        var par = $(this).parents('.fademore');
        var scroll = $('.fademore__scroll', par);
        if ($(this).height() > 275) {
            scroll.height(275);
            // scroll.css('height', 'auto');
            $('.fademore__more', par).css('display', 'block');
            $('.fademore__fade', par).show();
        }
    });

    $('.fademore__more').click(function(e) {
        e.preventDefault();

        var timer = $(this).data('timer');
        clearTimeout(timer);

        var fade = $('.fademore__fade', $(this).parent());
        var scroll = $('.fademore__scroll', $(this).parent());
        var inner = $('.fademore__inner', $(this).parent());

        if ($(this).text() == 'More') {
            $(this).text('Less');
            $(this).data('orig', scroll.height());
            scroll.height(inner.height());
            fade.addClass('fademore__fade--open');
            $(this).data('timer', setTimeout(function() { fade.css('bottom', '-100px'); }, 1000));

        } else {
            $(this).text('More');
            scroll.height($(this).data('orig'));
            fade.css('bottom', 0).removeClass('fademore__fade--open');
        }
    });

    $('#js-newsletter-signup').on('click', function (e) {
        e.preventDefault();
        var email = $('#newsletter_email').val();
        var form = $('#js-newsletter-signup-form');

        if (email != "") {
            $.ajax({
                type: 'POST',
                url: '/newsletters/footer-signup',
                data: {contact_email: email}
            }).success(function (data) {
                if (data.payload.status) {
                    form.fadeOut(function () {
                        $('#js-newsletter-response').html(data.payload.message)
                        $('#js-newsletter-response').fadeIn();
                    });
                } else {
                    form.append('<p class="newsletter-error">' + data.payload.error + '</p>');
                }
            });
        }
    });

    $('.js-form-filter').on('change', function(e) {
        var params = $(this).closest('form').serialize();
        window.location.assign(window.location.origin + window.location.pathname + '?' + params);
    });

    document.querySelector('[data-action="close-notice"]')?.addEventListener('click', (e) => {
        e.preventDefault();

        document.querySelector('body').classList.remove('has-notice-bar');

        fetch('/index/clear-site-notice?key=' + e.currentTarget.dataset.noticeKey, {
            method: 'GET',
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    for (const video of document.querySelectorAll('.js-video-video')) {
        const player = new Vimeo.Player(video.querySelector('iframe'));

        video?.addEventListener('click', async (event) => {
            const paused = await player.getPaused();

            paused ? player.play() : player.pause();
        });

        // Set data attribute to hide play icon when video is playing
        player.on('play', () => video.setAttribute('data-playing', ''));

        // Remove data attribute to show play icon when video is paused
        player.on('pause', () => video.removeAttribute('data-playing'));
    }
});

function svg(icon) {
    return '<svg class="icon-' + icon + '">' +
        '<use xlink:href="' + Hideaways.svgSymbolsFile + '#icon-' + icon + '" />' +
        '</svg>'
}

function scrollTo($target, hasPopup)
{
    var top = $target.offset().top;
    var margin = parseInt($target.css('marginTop'));

    if (!isNaN(margin)) {
        top -= margin;
    }

    var items = [
        $('#admin-bar'),
        $('#debug-bar'),
        $('.header'),
        $('.header-sub-nav')
    ];

    for (var i = 0; i < items.length; i++) {
        if (items[i].length > 0) {
            top -= items[i].outerHeight();
        }
    }

    if ($target.length && !hasPopup) {
        $('body, html').animate({
            scrollTop: top
        });
    }
}

//=include d3r-accordion/dist/accordion.js
window.accordionResize = [];
if (document.querySelectorAll('.js-accordion').length > 0) {
    var accordion = new Accordion({
        selector: '.js-accordion',
        selectorTrigger: '.js-accordion__trigger',
        openOnLoad: false,
        scrollTo: false,
        disable: '(max-width: 999px)',
        retainHead: true
    });

    window.accordionResize.push(accordion)
}
